import Staff from '@/components/Settings/Staff/index.vue'
import Print from '@/components/Settings/Print/printSettings.vue'
import Firms from '@/components/Settings/Firms/index.vue'
import Account from '@/components/Settings/Account/index.vue'
import Asset from '@/components/Settings/Asset/index.vue'
import Loan from '@/components/Settings/Loan/index.vue'
import Loanadvances from '@/components/Settings/Loanadvances/index.vue'
import Godawn from '@/components/Settings/Godawn/index.vue'
import HumanResource from '@/components/Settings/HumanResource/index.vue'
import StaffAttendance from '@/components/Settings/StaffAttendance/staffAttendance.vue'
import LetterHead from '@/components/Settings/LetterHead/LetterHead.vue'
import Todo from '@/components/Settings/Todo/todo.vue'
import Payroll from '@/components/Settings/Payroll/payroll.vue'
import AdminAccounts from '@/components/Settings/AdminAccounts/index.vue'
import ProductGroup from '@/components/Settings/ProductGroup/productGroup.vue'
import ProductCategory from '@/components/Settings/ProductCategory/productCategory.vue'
import ProductRateCategory from '@/components/Settings/ProductRateCategory/productRateCategory.vue'
import ProductSet from '@/components/Settings/ProductSet/productSet.vue'
import ProductType from '@/components/Settings/ProductType/ProductType.vue'
import ProductUniqueId from '@/components/Settings/ProductUniqueId/ProductUniqueId.vue'
import ProductOffers from '@/components/Settings/ProductOffers/ProductOffers.vue'
import ProductReplacement from '@/components/Settings/ProductReplacement/ProductReplacement.vue';
import productDrawer from '@/components/Settings/productDrawer/productDrawer.vue';

import DataManagement from '@/components/Settings/DataManagement/dataManagement.vue'
import FirmSettings from '@/components/Settings/FirmSettings/FirmSettings.vue'
import Branch from '@/components/Settings/Branch/Branch.vue'
import Transfer from '@/components/Settings/Transactions/Transfer.vue'
import ShopSettings from '@/components/Settings/ShopSettings/ShopSettings.vue'
import Infrastructure from '@/components/Settings/Infrastructure/Infrastructure.vue';
import GodawnBulkTransfer from '@/components/Settings/Godawn/BulkTransfer.vue'
import ImportFromExcel from '@/components/Settings/DataManagement/ImportFromExcel.vue';
import ImportCustomerFromExcel from '@/components/Settings/DataManagement/ImportCustomerFromExcel.vue';
import ImportSupplierFromExcel from '@/components/Settings/DataManagement/ImportSupplierFromExcel.vue';
import ProductManufacturing from '@/components/Settings/ProductManufacturing/ProductManufacturing.vue';
import ProductDamage from '@/components/Settings/ProductDamage/ProductDamage.vue';
import ProductRepair from '@/components/Settings/ProductRepair/ProductRepair.vue';
import OrderSettings from '@/components/Settings/OrderSettings/OrderSettings.vue';
import LeadSettings from '@/components/Settings/LeadSettings/LeadSettings.vue';

export default [{
  path: 'staff',
  name: 'Staff',
  component: Staff,
  meta: {requiresAuth: true}
}, 
{
  path: 'print',
  name: 'Print',
  component: Print,
  meta: {requiresAuth: true}
}, 
{
  path: 'firms',
  name: 'Firms',
  component: Firms,
  meta: {requiresAuth: true}
},
{
  path: 'firm-settings',
  name: 'FirmSettings',
  component: FirmSettings,
  meta: {requiresAuth: true}
}, 
{
  path: 'firms/:isNew',
  name: 'FirmsNew',
  component: Firms,
  meta: {requiresAuth: true}
}, 
{
  path: 'account',
  name: 'Account',
  component: Account,
  meta: {requiresAuth: true}
},
{
  path: 'account/:isNew',
  name: 'AccountNew',
  component: Account,
  meta: {requiresAuth: true}
}, 
{
  path: 'asset',
  name: 'Asset',
  component: Asset,
  meta: {requiresAuth: true}
},
{
  path: 'loan',
  name: 'Loan',
  component: Loan,
  meta: {requiresAuth: true}
},
{
  path: 'loanadvances',
  name: 'Loanadvances',
  component: Loanadvances,
  meta: {requiresAuth: true}
},
{
  path: 'godawn',
  name: 'Godawn',
  component: Godawn,
  meta: {requiresAuth: true}
},
{
  path: 'godawn-bulk-transfer',
  name: 'GodawnBulkTransfer',
  component: GodawnBulkTransfer,
  meta: {requiresAuth: true}
},
{
  path: 'humanResource',
  name: 'HumanResource',
  component: HumanResource,
  meta: {requiresAuth: true}
},
{
  path: 'staffAttendance',
  name: 'StaffAttendance',
  component: StaffAttendance,
  meta: {requiresAuth: true}
},
{
  path: 'LetterHead',
  name: 'LetterHead',
  component:LetterHead,
  meta: {requiresAuth: true}
},
{
  path: 'todo',
  name: 'Todo',
  component:Todo,
  meta: {requiresAuth: true}
},
{
  path: 'payroll',
  name: 'Payroll',
  component: Payroll,
  meta: {requiresAuth: true}
},
{
  path: 'admin-accounts',
  name: 'AdminAccounts',
  component: AdminAccounts,
  meta: {requiresAuth: true}
},
{
    path: 'data-management',
    name: 'DataManagement',
    component: DataManagement,
    meta: {requiresAuth: true}
},
{
  path: 'product-grouping',
  name: 'ProductGroup',
  component: ProductGroup,
  meta: {requiresAuth: true}
}, 
{
  path: 'product-set',
  name: 'ProductSet',
  component: ProductSet,
  meta: {requiresAuth: true}
}, 
{
  path: 'product-type',
  name: 'ProductType',
  component: ProductType,
  meta: {requiresAuth: true}
}, 
{
  path: 'product-category',
  name: 'ProductCategory',
  component: ProductCategory,
  meta: {requiresAuth: true}
},
{
  path: 'rate-category',
  name: 'ProductRateCategory',
  component: ProductRateCategory,
  meta: {requiresAuth: true}
}, 
{
   path: 'product-grouping/:isNew/:redirect',
   name: 'ProductGroupWithRedirect',
   component: ProductGroup,
   meta: {requiresAuth: true}
}, 
{
   path: 'product-set/:isNew/:redirect',
   name: 'ProductSetWithRedirect',
   component: ProductSet,
   meta: {requiresAuth: true}
}, 
{
  path: 'product-category/:isNew/:redirect',
  name: 'ProductCategoryWithRedirect',
  component: ProductCategory,
  meta: {requiresAuth: true}
}, 
{
  path: 'product-type/:isNew/:redirect',
  name: 'ProductTypeWithRedirect',
  component: ProductType,
  meta: {requiresAuth: true}
},
{
  path: 'product-offers',
  name: 'ProductOffers',
  component: ProductOffers,
  meta: {requiresAuth: true}
},
{
  path: 'product-unique-id',
  name: 'ProductUniqueId',
  component: ProductUniqueId,
  meta: {requiresAuth: true}
}, 
{
  path: 'Branch',
  name: 'Branch',
  component: Branch,
  meta: {requiresAuth: true}
},
{
  path: 'transfer',
  name: 'Transfer',
  component: Transfer,
  meta: {requiresAuth: true}
}, 
{
  path: 'shop-settings',
  name: 'ShopSettings',
  component: ShopSettings,
  meta: {requiresAuth: true}
}, 
{
  path: 'infrastructure',
  name: 'Infrastructure',
  component: Infrastructure,
  meta: {requiresAuth: true}
}, 
{
  path: 'data-import',
  name: 'ImportFromExcel',
  component: ImportFromExcel,
  meta: {requiresAuth: true}
}, 
{
  path: 'customer-import',
  name: 'ImportCustomerFromExcel',
  component: ImportCustomerFromExcel,
  meta: {requiresAuth: true}
}, 
{
  path: 'supplier-import',
  name: 'ImportSupplierFromExcel',
  component: ImportSupplierFromExcel,
  meta: {requiresAuth: true}
}, 
{
  path: 'product-manufacturing',
  name: 'ProductManufacturing',
  component: ProductManufacturing,
  meta: {requiresAuth: true}
}, 
{
  path: 'product-damage',
  name: 'ProductDamage',
  component: ProductDamage,
  meta: {requiresAuth: true}
}, 
{
  path: 'product-replacement',
  name: 'ProductReplacement',
  component: ProductReplacement,
  meta: {requiresAuth: true}
},
{
  path: 'product-repair',
  name: 'ProductRepair',
  component: ProductRepair,
  meta: {requiresAuth: true}
},
{
  path: 'product-drawer',
  name: 'productDrawer',
  component: productDrawer,
  meta: {requiresAuth: true}
}, 
{
  path: 'order-settings',
  name: 'OrderSettings',
  component: OrderSettings,
  meta: {requiresAuth: true}
},
{
  path: 'lead-settings',
  name: 'LeadSettings',
  component: LeadSettings,
  meta: {requiresAuth: true}
}, 
]



// WEBPACK FOOTER //
// ./src/router/home/settings/index.js